import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { LiveProducerView } from './showLiveProducer';
import { LAYOUT_SELECT_VIEW } from '../../redux/layout/layoutReducer';
import { ViewType } from '../../models/layoutClass';

import './LiveControls.scss';

// import { ReactComponent as PatternDefaultSvg } from '../../assets/icons/pattern/pattern-default.svg';
// import { ReactComponent as PatternBigSvg } from '../../assets/icons/pattern/pattern-big.svg';
// import { ReactComponent as PatternSplitSvg } from '../../assets/icons/pattern/pattern-split.svg';
// import { ReactComponent as PatternTheaterSvg } from '../../assets/icons/pattern/pattern-theater.svg';
// import { ReactComponent as PatternSIDEBYSIDESvg } from '../../assets/icons/pattern/pattern-SIDEBYSIDE.svg';
// import { ReactComponent as PatternPipSvg } from '../../assets/icons/pattern/pattern-pip.svg';

import { ReactComponent as LayoutCinema2 } from '../../assets/icons/layouts/layouts-cinema2.svg';
import { ReactComponent as LayoutCinema3 } from '../../assets/icons/layouts/layouts-cinema3.svg';
import { ReactComponent as LayoutCinema4 } from '../../assets/icons/layouts/layouts-cinema4.svg';
import { ReactComponent as LayoutClassic1 } from '../../assets/icons/layouts/layouts-classic1.svg';
import { ReactComponent as LayoutClassic2 } from '../../assets/icons/layouts/layouts-classic2.svg';
import { ReactComponent as LayoutClassic3 } from '../../assets/icons/layouts/layouts-classic3.svg';
import { ReactComponent as LayoutClassic4 } from '../../assets/icons/layouts/layouts-classic4.svg';
import { ReactComponent as LayoutCover1 } from '../../assets/icons/layouts/layouts-cover1.svg';
import { ReactComponent as LayoutCover2 } from '../../assets/icons/layouts/layouts-cover2.svg';
import { ReactComponent as LayoutCover3 } from '../../assets/icons/layouts/layouts-cover3.svg';
import { ReactComponent as LayoutCover4 } from '../../assets/icons/layouts/layouts-cover4.svg';
import { ReactComponent as LayoutPip2 } from '../../assets/icons/layouts/layouts-pip2.svg';
import { ReactComponent as LayoutPip3 } from '../../assets/icons/layouts/layouts-pip3.svg';
import { ReactComponent as LayoutPip4 } from '../../assets/icons/layouts/layouts-pip4.svg';
import { ReactComponent as LayoutSide2 } from '../../assets/icons/layouts/layouts-side2.svg';
import { ReactComponent as LayoutSide3 } from '../../assets/icons/layouts/layouts-side3.svg';
import { ReactComponent as LayoutSide4 } from '../../assets/icons/layouts/layouts-side4.svg';
import { ReactComponent as LayoutSplit3 } from '../../assets/icons/layouts/layouts-split3.svg';
import { ReactComponent as LayoutSplit4 } from '../../assets/icons/layouts/layouts-split4.svg';

import { ApiService } from '../../services/api-service';
import { container } from 'tsyringe';

import { useSharedState } from '../../utils/helpers';

// import { FullScreen, useFullScreenHandle } from "react-full-screen";
import { setLiveControls } from '../../redux/layout/layoutActions';
import { styled, Tooltip, TooltipProps } from '@mui/material';
import ShareLink from '../shareLink/shareLink';
import { ActionType, GroupType } from '../../models/actionClass';
import { tooltipClasses } from '@mui/material';
import { TOGGLE_PRODUCER_MUTED, TOGGLE_PRODUCER_VIDEO_MUTED } from '../../redux/producers/producersReducer';
import { WebRTCsdkService } from '../../services/webrtcsdk-service';
import { SoundService } from '../../services/sound-service';
import { MeetingStore, SharingState } from '../../models/meetingClass';
import { MEETING_SET_SHARING_CONTENT } from '../../redux/meeting/meetingReducer';
import useOnClickOutside from '../hooks/useOnClickOutside';
import { Producer, ProducerType } from '../../models/producerClass';

import StopSharingDialog from './stopSharingDialog';
import { PTApiService } from '../../services/ptapi-service';
import { PeopleService } from '../../services/people-service';
import { OrchestratorService } from '../../services/orchestrator-service';
import { People } from '../../models/peopleClass';
import { useNotTooFast } from '../hooks/useNotTooFast';




const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} enterDelay={500} leaveDelay={200} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#f0eff0',
    color: '#4a4a4a',
    padding: 5,
    maxWidth: 270,
    fontSize: theme.typography.pxToRem(12),
    // border: '1px solid #dadde9',
    boxShadow: '2px 2px 4px 2px rgba(0, 0, 0, 0.3)'
  },
}));
const ControlsTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} enterDelay={800} leaveDelay={100} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#f0eff0',
    color: '#4a4a4a',
    padding: 5,
    maxWidth: 270,
    marginLeft: 5,
    fontSize: theme.typography.pxToRem(10),
    // border: '1px solid #dadde9',
    boxShadow: '1px 1px 3px 1px rgba(0, 0, 0, 0.3)'
  },
}));


interface MicrophoneLevelProps {
  muteState: any,
  handleClick: any
}

const MicrophoneLevel = (props: MicrophoneLevelProps) => {

  const [webRTCsdkService] = useState(container.resolve(WebRTCsdkService));
  const [sdkVolumeLevel] = useSharedState(webRTCsdkService.volumeLevel$);
  const [micVolume, setMicVolume] = useState(1);

  useEffect(() => {
    // 9 can be changed in range 6..14 to increase/decrease level sensibility at display
    if (props.muteState.audioHardMute) {
      setMicVolume(-1);
    } else if (props.muteState.audioMute) {
      setMicVolume(0);
    } else {
      setMicVolume(1 + Math.round(9 * sdkVolumeLevel));
    }
  }, [props.muteState.audioMute, props.muteState.audioHardMute, sdkVolumeLevel])

  return (
    <div className={'LivePreview-item ' + ('LivePreview-item-mic-' + micVolume)} onClick={props.handleClick}></div>
  )
}

const ViewLink = () => {

  // const [ptApiService] = useState(container.resolve(PTApiService));
  // const [orchestratorService] = useState(container.resolve(OrchestratorService));

  // const linkPoupRef = useRef(undefined);
  // const [closedTime, setClosedTime] = useState(Date.now());

  // const [moderatorUrl, setModeratorUrl] = useState<string>(null);
  // const [presenterUrl, setPresenterUrl] = useState<string>(null);
  // const [attendeeUrl, setAttendeeUrl] = useState<string>(null);

  // useEffect(() => {
  //   const sub = orchestratorService.meetingInitializedObservable.subscribe(() => {
  //     setModeratorUrl(ptApiService.studioModeratorJoinUrl);
  //     setPresenterUrl(ptApiService.ptEventJoinUrlsCurrentValue?.panelistUrl);
  //     setAttendeeUrl(ptApiService.ptEventJoinUrlsCurrentValue?.attendeeUrl);
  //   });

  //   return () => sub.unsubscribe();
  // })

  // useOnClickOutside(linkPoupRef, (e) => {
  //   if (viewLink) {
  //     setViewLink(false);
  //     setClosedTime(Date.now());
  //   }
  // });

  // const openLink = () => {
  //   if (Date.now() - closedTime > 500) {
  //     setViewLink(true);
  //   }
  // }

  // const [viewLink, setViewLink] = useState(false);

  const [apiService] = useState(container.resolve(ApiService));

  const toggleRegisterPopup = () => {
    apiService.toggleRegisterPopup();
  }



  return (
    <div className="LivePreview-btn">
      <HtmlTooltip title='Invite Guest' placement="bottom">
        <span><div className="LivePreview-item LivePreview-item-add-idle" onClick={() => toggleRegisterPopup()}>
        </div></span>
      </HtmlTooltip>
    </div>
  )
}

const ShareContent = () => {

  // const dispatch = useDispatch();
  // const [webRTCsdkService] = useState(container.resolve(WebRTCsdkService));
  // const meetingStore: MeetingStore = useSelector((state: any) => state.meetingStore);

  // const [showStopSharing, setShowStopSharing] = useState(false);

  // const toggleShareContent = () => {
  //   if (meetingStore.sharingContent) {
  //     if (webRTCsdkService.stopContentShare()) {
  //       console.log('stop shareContent');

  //       dispatch({ type: MEETING_SET_SHARING_CONTENT, payload: { sharingContent: false, sharingLocalContent: SharingState.NONE } });

  //       if (meetingStore.currentVideoId !== '' && meetingStore.currentVideoId !== 'screenshare') {
  //         webRTCsdkService.setVideoSharingAction('stop');
  //       }
  //     }
  //   } else if (meetingStore.receivingContent) {
  //     setShowStopSharing(true);
  //   } else {
  //     handleStopSharingDialog('start');
  //   }
  // }

  // const handleStopSharingDialog = (value) => {
  //   setShowStopSharing(false);
  //   if (value === 'cancel') {
  //     console.log('Dont start sharing');
  //   } else {
  //     console.log('Start sharing');
  //     if (webRTCsdkService.startContentShare()) {
  //       console.log('open shareContent system dialog');
  //     }
  //   }
  // }
  const [apiService] = useState(container.resolve(ApiService));

  const toggleRegisterPopup = () => {
    apiService.toggleRegisterPopup();
  }

  return (
    <>
      <div className={"LivePreview-btn"}>
          <HtmlTooltip title={'Share Screen'} placement="bottom">
            <span><div className={"LivePreview-item  LivePreview-item-share-idle"} onClick={() => toggleRegisterPopup()}>
            </div></span>
          </HtmlTooltip>
        </div>

      {/* <div className={"LivePreview-btn " + (meetingStore?.sharingContent ? 'LivePreview-btn-on' : '')} onClick={toggleShareContent}>
        <HtmlTooltip title={meetingStore?.sharingContent ? 'Stop Sharing' : 'Share Screen'} placement="bottom">
          <span><div className={"LivePreview-item " + (meetingStore?.sharingContent ? "LivePreview-item-share-stop" : "LivePreview-item-share-start")}>
          </div></span>
        </HtmlTooltip>
      </div>
      <StopSharingDialog open={showStopSharing} onClose={(e) => handleStopSharingDialog(e)} remoteParticipantName={meetingStore.presenterName}></StopSharingDialog> */}
    </>
  )
}


const LiveControls = () => {

  const [webRTCsdkService] = useState(container.resolve(WebRTCsdkService));
  const [ptApiService] = useState(container.resolve(PTApiService));
  const [soundService] = useState(container.resolve(SoundService));

  const [peopleService] = useState(container.resolve(PeopleService));
  const [peoples] = useSharedState(peopleService.peoples$)

  const dispatch = useDispatch();
  const [controlsVisible, setControlsVisible] = useState(true);

  const producers = useSelector((state: any) => state.producers);
  const [selfPeople, setSelfPeople] = useState<People>(null);

  const [muteState, setMuteState] = useState({ audioMute: false, audioHardMute: false, videoMute: false, videoHardMute: false });

  const checkNotTooFast = useNotTooFast(400);

  const toggleControls = () => {
    console.log('layout toggle control');
    const ctrlVisible = !controlsVisible;
    setControlsVisible(ctrlVisible);
    dispatch(setLiveControls(ctrlVisible));

    soundService.playSoundStart('ToggleStageView');

    // setTimeout(() => {
    //   window.dispatchEvent(new Event('resize'));
    // }, 0);
  }

  const toggleAudioMute = () => {
    if (checkNotTooFast() && selfPeople) {
      const audioMute = !selfPeople.audioMute;
      selfPeople.audioHardMute = false;
      setMuteState({ ...muteState, audioMute });
      webRTCsdkService.setAudioMuted(audioMute);
      // ptApiService.setParticipantMute(selfPeople.endpointGUID, 'audio', audioMute, false);
      peopleService.setParticipantMute(selfPeople.endpointGUID, 'audio', audioMute, false);
    }
  }

  const toggleVideoMute = () => {
    if (checkNotTooFast() && selfPeople) {
      const videoMute = !selfPeople.videoMute;
      selfPeople.videoHardMute = false;
      dispatch({ type: TOGGLE_PRODUCER_VIDEO_MUTED, payload: { producer: selfPeople, videoMute: videoMute } });
      setMuteState({ ...muteState, videoMute });
      webRTCsdkService.setVideoMuted(videoMute);
      // ptApiService.setParticipantMute(selfPeople.endpointGUID, 'video', videoMute, false);
      peopleService.setParticipantMute(selfPeople.endpointGUID, 'video', videoMute, false);
    }
  }

  useEffect(() => {
    if (peoples) {
      // search myself
      const myself = peoples.find(p => p.isSelf) as People;
      if (myself) {
        setSelfPeople(myself);
        setMuteState({ audioMute: myself.audioMute, audioHardMute: myself.audioHardMute, videoMute: myself.videoMute, videoHardMute: myself.videoHardMute });
      }
    }
  }, [peoples])

  return (
    <>
      {controlsVisible &&
        <div className="LivePreview-menu">

          <div className={"LivePreview-btn " + (muteState.videoMute ? 'LivePreview-btn-muted' : '')}>
            <HtmlTooltip title={muteState.videoMute ? 'Unmute Video' : 'Mute Video'} placement="bottom">
              <span><div className={"LivePreview-item " + (muteState.videoHardMute ? 'LivePreview-item-cam-hard-muted' :
                (muteState.videoMute ? 'LivePreview-item-cam-muted' : 'LivePreview-item-cam'))}
                onClick={toggleVideoMute}></div></span>
            </HtmlTooltip>
          </div>
          <div className={"LivePreview-btn " + (muteState.audioMute ? 'LivePreview-btn-muted' : '')}>
            <HtmlTooltip title={muteState.audioMute ? 'Unmute Audio' : 'Mute Audio'} placement="bottom">
              <span>
                <MicrophoneLevel muteState={muteState} handleClick={toggleAudioMute}></MicrophoneLevel>
              </span>
            </HtmlTooltip>
          </div>
          <ShareContent></ShareContent>
          <ViewLink></ViewLink>
        </div>
      }

        <ControlsTooltip title={controlsVisible ? 'Hide Video Controls' : 'Show Videos Controls'} placement="top">
          <div className={'full-height ' + (controlsVisible ? 'small' : 'expanded')} onClick={() => toggleControls()}></div>
        </ControlsTooltip>


      {/* <button onClick={handleFS.enter}>
          FS enter
      </button> */}

      {/* <FullScreen handle={handleFS} onChange={onFSchange}> */}
      {/* <button onClick={handleFS.exit}>
            FS exit
        </button> */}
      {/* </FullScreen> */}

    </>
  );
}

const LiveStreamStatus = () => {

  const [showLiveStreamRunning, setShowLiveStreamRunning] = useState(0);

  const liveStreamRunning = useSelector((state: any) => state.layout.liveStreamRunning);

  const [messageTimer, setMessageTimer] = useState(null);

  useEffect(() => {
    console.log('liveStreamRunning change', liveStreamRunning);
    // live stream started
    if (liveStreamRunning && showLiveStreamRunning <= 0) {
      // show STREAM STARTED and reset after 10sec
      setShowLiveStreamRunning(2);
      clearTimeout(messageTimer);
      setMessageTimer(setTimeout(() => {
        setShowLiveStreamRunning(1);
      }, 10000));
    }

    // live stream stopped
    if (!liveStreamRunning && showLiveStreamRunning >= 1) {
      // show STREAM ENDED and reset after 10sec
      setShowLiveStreamRunning(-2);
      clearTimeout(messageTimer);
      setMessageTimer(setTimeout(() => {
        setShowLiveStreamRunning(-1);
      }, 10000));
    }
  }, [liveStreamRunning]);

  return (
    <>
      {showLiveStreamRunning === 2 &&
        <div className="livestream">LIVESTREAM STARTED</div>
      }
      {showLiveStreamRunning === -2 &&
        <div className="livestream">LIVESTREAM STOPPED</div>
      }
    </>
  )
}

const LiveLayout = () => {

  const [apiService] = useState(container.resolve(ApiService));
  const [soundService] = useState(container.resolve(SoundService));
  const dispatch = useDispatch();
  const [viewLayout, setViewLayout] = useSharedState(apiService.layoutView$);

  const producers = useSelector((state: any) => state.producers);
  const controlsVisible = useSelector((state: any) => state.layout.liveControlsVisible);

  // const [visibleLayout, setVisibleLayout] = useState(ViewType.CLASSIC);
  let visibleLayout = viewLayout;

  const selectViewLayout = (view) => {
    setViewLayout(view);
    visibleLayout = view;

    apiService.updateReason = { group: GroupType.LAYOUT, action: ActionType.SELECT, id: view };

    // dispatch selected view in reducer
    dispatch({ type: LAYOUT_SELECT_VIEW, payload: { view: viewLayout } });
  }

  const IsSelected = (view) => {
    if (visibleLayout === view) {
      return 'selected';
    }
    return '';
  }

  const prodLen = producers.filter(p => p.isLive).length;
  if (prodLen <= 2 && viewLayout === ViewType.SPLIT) {
    visibleLayout = ViewType.COVER;
  } else if (prodLen <= 1 && (viewLayout == ViewType.CINEMA || viewLayout == ViewType.SIDEBYSIDE)) {
    visibleLayout = ViewType.CLASSIC;
  } else if (prodLen <= 1 && (viewLayout == ViewType.PIP)) {
    visibleLayout = ViewType.COVER;
  }

  const isContentShared = producers
  .some(p => p.isLive && p.type === ProducerType.CONTENT_SHARING);

  if (isContentShared) {
    if (visibleLayout == ViewType.COVER || visibleLayout == ViewType.SPLIT) {
      visibleLayout = ViewType.CINEMA;
    }
    if (visibleLayout == ViewType.CLASSIC && length == 1) {
      visibleLayout = ViewType.COVER;
    }
  }


  useEffect(() => {
    console.log('LivePreview updated view=', viewLayout);
    // dispatch selected view in reducer
    dispatch({ type: LAYOUT_SELECT_VIEW, payload: { view: viewLayout } });
  }, [viewLayout]);



  return (
    <>
      {controlsVisible &&
        <div className="LivePreview-layout-toolbar" id="layoutToolbarREF">
          <Tooltip title="Classic">
            <div className="LivePreview-select" onClick={() => selectViewLayout(ViewType.CLASSIC)}>
              {prodLen <= 1 && <LayoutClassic1 className={"LivePreview-layout-icon " + IsSelected(ViewType.CLASSIC)} />}
              {prodLen === 2 && <LayoutClassic2 className={"LivePreview-layout-icon " + IsSelected(ViewType.CLASSIC)} />}
              {prodLen === 3 && <LayoutClassic3 className={"LivePreview-layout-icon " + IsSelected(ViewType.CLASSIC)} />}
              {prodLen >= 4 && <LayoutClassic4 className={"LivePreview-layout-icon " + IsSelected(ViewType.CLASSIC)} />}
            </div>
          </Tooltip>
          {!isContentShared &&
          <Tooltip title="Cover">
            <div className="LivePreview-select" onClick={() => selectViewLayout(ViewType.COVER)}>
              {prodLen <= 1 && <LayoutCover1 className={"LivePreview-layout-icon " + IsSelected(ViewType.COVER)} />}
              {prodLen === 2 && <LayoutCover2 className={"LivePreview-layout-icon " + IsSelected(ViewType.COVER)} />}
              {prodLen === 3 && <LayoutCover3 className={"LivePreview-layout-icon " + IsSelected(ViewType.COVER)} />}
              {prodLen >= 4 && <LayoutCover4 className={"LivePreview-layout-icon " + IsSelected(ViewType.COVER)} />}
            </div>
          </Tooltip>
          }
          {prodLen >= 3 && prodLen < 6 && !isContentShared &&
            <Tooltip title="Split Screen">
              <div className="LivePreview-select" onClick={() => selectViewLayout(ViewType.SPLIT)}>
                {prodLen === 3 && <LayoutSplit3 className={"LivePreview-layout-icon " + IsSelected(ViewType.SPLIT)} />}
                {prodLen >= 4 && <LayoutSplit4 className={"LivePreview-layout-icon " + IsSelected(ViewType.SPLIT)} />}
              </div>
            </Tooltip>
          }
          {prodLen >= 2 &&
            <Tooltip title="Cinema">
              <div className="LivePreview-select" onClick={() => selectViewLayout(ViewType.CINEMA)}>
                {prodLen === 2 && <LayoutCinema2 className={"LivePreview-layout-icon " + IsSelected(ViewType.CINEMA)} />}
                {prodLen === 3 && <LayoutCinema3 className={"LivePreview-layout-icon " + IsSelected(ViewType.CINEMA)} />}
                {prodLen >= 4 && <LayoutCinema4 className={"LivePreview-layout-icon " + IsSelected(ViewType.CINEMA)} />}
              </div>
            </Tooltip>
          }
          {prodLen >= 2 && prodLen < 6 &&
            <Tooltip title="Side by Side">
              <div className="LivePreview-select" onClick={() => selectViewLayout(ViewType.SIDEBYSIDE)}>
                {prodLen === 2 && <LayoutSide2 className={"LivePreview-layout-icon " + IsSelected(ViewType.SIDEBYSIDE)} />}
                {prodLen === 3 && <LayoutSide3 className={"LivePreview-layout-icon " + IsSelected(ViewType.SIDEBYSIDE)} />}
                {prodLen >= 4 && <LayoutSide4 className={"LivePreview-layout-icon " + IsSelected(ViewType.SIDEBYSIDE)} />}
              </div>
            </Tooltip>
          }
          {prodLen >= 2 &&
            <Tooltip title="Picture in Picture">
              <div className="LivePreview-select" onClick={() => selectViewLayout(ViewType.PIP)}>
                {prodLen === 2 && <LayoutPip2 className={"LivePreview-layout-icon " + IsSelected(ViewType.PIP)} />}
                {prodLen === 3 && <LayoutPip3 className={"LivePreview-layout-icon " + IsSelected(ViewType.PIP)} />}
                {prodLen >= 4 && <LayoutPip4 className={"LivePreview-layout-icon " + IsSelected(ViewType.PIP)} />}
              </div>
            </Tooltip>
          }
        </div>
      }

    </>
  );
}

const LivePreview: React.FC = () => {


  return (
    <div className="LivePreview" data-testid="LivePreview" id="LivePreview">

      <LiveControls></LiveControls>

      <div className="LivePreview-wrapper" id="LivePreview-wrapper">
        <div className="LivePreview-frame">
          <LiveProducerView></LiveProducerView>
        </div>
      </div>

      <LiveLayout></LiveLayout>

      <LiveStreamStatus></LiveStreamStatus>

    </div>
  );
}

export default LivePreview;
